import { put } from 'redux-saga/effects'
import UserService from '../../../services/User'
import RESTModelNormalizationSchemas from '../../models/RESTModelNormalizationSchemas'
import createDataStoreSliceFetchHandlers from './helpers/createDataStoreFetchHandlers'
import LayoutActions from '../../actions/Layout'
import ErrorActions from '../../actions/Error'
import OLError from '../../../modules/errorHandling/models/OLError'
import { HTTP_RESPONSE_CODES, IS_DEV_ENV } from '../../../constants/general'

const mergedEntityNames = [
  RESTModelNormalizationSchemas.user.entityName,
  RESTModelNormalizationSchemas.image.entityName,
  RESTModelNormalizationSchemas.device.entityName
]

const defaultHandlersFactory = createDataStoreSliceFetchHandlers(
  'user',
  UserService,
  RESTModelNormalizationSchemas.user.schema,
  mergedEntityNames
)

const UserDataStoreSagaHandlers = DataStoreSlice => {
  const baseHandlers = defaultHandlersFactory(DataStoreSlice)
  const fetchId = baseHandlers.fetchId

  return {
    ...baseHandlers,
    /**
     * Single-user fetches use GET /user/:id so devices are included.
     * The list endpoint does not support filtering by id.
     */
    fetch: function * (action) {
      const { data: { ids, onFinish } } = action

      if (Array.isArray(ids) && ids.length === 1) {
        try {
          yield put(LayoutActions.setIsLoading(true, fetchId))
          const result = yield UserService.GetUserInfo(ids[0])
          const wrapped = {
            data: {
              items: result?.data ? [result.data] : [],
              totalCount: result?.data ? 1 : 0
            }
          }
          yield put(DataStoreSlice.actions.fetchResult(wrapped))
        } catch (e) {
          const status = e?.response?.status
          // Out-of-scope / missing users are common when denormalizing chat senders.
          // Do not toast; store a stub so hooks stop refetching every cache window.
          if (status === HTTP_RESPONSE_CODES.NOT_FOUND) {
            yield put(DataStoreSlice.actions.addItem(ids[0], {
              id: ids[0],
              firstName: '',
              lastName: '',
              isUnavailable: true
            }))
          } else {
            const isUnauthorized = status === HTTP_RESPONSE_CODES.UNAUTHORIZED
            yield put(ErrorActions.trigger(
              new OLError(
                '[user] DataStoreSagaHandlers.fetch: Failed to fetch the requested user(s)',
                'Failed to fetch the requested user(s)',
                e
              ),
              !isUnauthorized,
              !isUnauthorized,
              !isUnauthorized,
              false
            ))
          }
        }
        try {
          typeof onFinish === 'function' && onFinish()
        } catch (e) {
          if (IS_DEV_ENV) {
            console.error(`${fetchId} onFinish error:`, e)
          }
        }
        yield put(LayoutActions.setIsLoading(false, fetchId))
        return
      }

      yield baseHandlers.fetch(action)
    }
  }
}

export default UserDataStoreSagaHandlers
